import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import type { Role } from '../../shared/models';
import { AuthService } from './auth.service';

// Nessuna sessione → /login. Se Supabase non è configurato (env vuote), l'auth è disabilitata:
// guard aperto (fallback dev), stessa filosofia di PromptService/QuestionService.
export const authGuard: CanActivateFn = async (): Promise<true | UrlTree> => {
  const auth = inject(AuthService);
  const router = inject(Router);
  await auth.whenReady();
  if (false === auth.enabled || null !== auth.sessionSignal()) {
    return true;
  }
  return router.createUrlTree(['/login']);
};

// Ruolo non incluso in `roles` → /intro. Auth disabilitata → guard aperto.
export const roleGuard = (roles: Role[]): CanActivateFn => {
  return async (): Promise<true | UrlTree> => {
    const auth = inject(AuthService);
    const router = inject(Router);
    await auth.whenReady();
    const role = auth.profileSignal()?.role_app.role_assigned;
    if (false === auth.enabled || (undefined !== role && roles.includes(role))) {
      return true;
    }
    return router.createUrlTree(['/intro']);
  };
};
